// This file is generated by pnpm icons:generate. Do not edit.

import {BellPlus_Stroke2_Corner0_Rounded as CanonicalBellPlus_Stroke2_Corner0_Rounded} from './Bell'

/** @deprecated Import BellPlus_Stroke2_Corner0_Rounded from `#/components/icons/Bell` instead. */
export const BellPlus_Stroke2_Corner0_Rounded =
  CanonicalBellPlus_Stroke2_Corner0_Rounded
